// ---- Importing required dependencies (External)——
// ---- Packages ----
import { CaretCircleUp } from "phosphor-react";
import React, { useState } from "react";

// ---- Importing required dependencies (Local)----
// ---- Styles ----
import { Button } from "./Styles";

// Main function - For ToTop Button
const ToTop = () => {
  const [visible, setVisible] = useState(false);

  // Toggle visibility of "To Top" button based on scroll position
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  // Scroll to top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <Button className="totop animate-bounce !w-fit">
      {/* "To Top" Button */}
      <span className="text-pent">
        <CaretCircleUp
          className="rounded-full gradient-bg"
          size={32}
          color="#563a2d"
          onClick={scrollToTop}
          style={{ display: visible ? "inline" : "none" }}
        />
      </span>
    </Button>
  );
};

export default ToTop;
